var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterMbl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 308,
    viewBox: "0 0 375 308",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "d875otzala"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FF",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBDED",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D2D3",
    strokeWidth: 1.74,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "m-64.015 66.205 173.08 29.955L420.94 52z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D2D3",
    strokeWidth: 1.74,
    strokeLinejoin: "round",
    d: "M420.94 51.61-64.015 65.815 317.5 12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D2D3",
    strokeWidth: 1.74,
    strokeLinejoin: "round",
    d: "M639.405 26.985 317.5 1.645-254.73 42.91-452.315-43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d875otzala)",
    fillRule: "nonzero",
    d: "m407.08 105.82 175.985 32.303L889.36 89.789 1113.405 115l-45.52 236H0l5.58-159.726 212.015-2.42z",
    transform: "translate(-474 -43)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMbl);
export default __webpack_public_path__ + "static/media/footer-mbl.bf24860cdaf2a6211ead69ff6844d5ef.svg";
export { ForwardRef as ReactComponent };